const ACADEMY_HOST = 'https://evisort-academy.sana.ai';
const ACADEMY_SANDBOX_HOST = 'https://evisort-academy-sbx.sana.ai';

const SANA_ACADEMY_URL_BY_CELL: Record<string, string> = {
  production: `${ACADEMY_HOST}/?login=oauth/productionenv`,
  eu1: `${ACADEMY_HOST}/?login=oauth/eu1env`,
  us1: `${ACADEMY_HOST}/?login=oauth/us1env`,
  demo: `${ACADEMY_HOST}/?login=oauth/demoenv`,
  release: `${ACADEMY_SANDBOX_HOST}/?login=oauth`,
};

// Examples:
//   clients.evisort.com         → 'production'
//   clients.eu1.evisort.com     → 'eu1'
//   clients.us1.evisort.com     → 'us1'
//   clients.demo.evisort.com    → 'demo'
//   clients.release.evisort.dev → 'release'
// Returns null when the hostname is not a recognised clients.* host.
export function getCurrentCell(
  hostname: string = globalThis.window.location.hostname,
): string | null {
  if (!hostname.startsWith('clients.')) return null;
  const [first] = hostname.slice('clients.'.length).split('.');
  if (!first) return null;
  return first === 'evisort' ? 'production' : first;
}

export function getSanaAcademyUrl(
  hostname: string = globalThis.window.location.hostname,
): string | null {
  const cell = getCurrentCell(hostname);
  if (!cell) return null;
  return SANA_ACADEMY_URL_BY_CELL[cell] ?? null;
}
